import { createComponent } from '@carvana/merch-components';

export const DesktopStickyPageNavigationWrapper = createComponent('div', {
  className:
    'sticky inset-x-0 top-xl z-[100] row-start-2 flex w-full px-2xl pb-4xl sm:col-span-2 md:col-span-1 md:px-0'
});

export const DesktopStickyPageNavigationInnerWrapper = createComponent('div', {
  className:
    'mx-auto flex w-full items-center justify-between overflow-hidden rounded-full bg-background-default p-md shadow-md'
});
